import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const creditMovementType = v.union(
  v.literal("charge"),
  v.literal("payment"),
  v.literal("adjustment"),
);

export const creditStatus = v.union(
  v.literal("pending"),
  v.literal("paid"),
  v.literal("overdue"),
  v.literal("partial"),
  v.literal("cancelled"),
);

export const validatorClientCredit = v.object({
  clientId: v.id("clients"),
  invoiceId: v.optional(v.id("invoices")),
  paymentId: v.optional(v.id("invoices_payments")),
  type: creditMovementType,
  amount: v.number(),
  balance: v.number(),
  dueDate: v.optional(v.number()),
  status: creditStatus,
  notes: v.optional(v.string()),
  internalControl,
});

export const client_credits = defineTable(validatorClientCredit)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_client_id", ["clientId"])
  .index("by_company_and_client", ["internalControl.companyId", "clientId"])
  .index("by_company_client_status", [
    "internalControl.companyId",
    "clientId",
    "status",
  ])
  .index("by_invoice_id", ["invoiceId"])
  .index("by_payment_id", ["paymentId"])
  .index("by_client_and_status", ["clientId", "status"])
  .index("by_client_and_type", ["clientId", "type"])
  .index("by_status", ["status"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ]);
